// src/components/NewAddressModal/NewAddressModal.jsx
import React, { useEffect, useState } from "react";
import "./NewAddressModal.css";
import InputField from "../InputField/InputField";
import Button from "../Button/Button";
import { useLanguage } from "../../LanguageProvider";

export default function NewAddressModal({
  isOpen,
  onClose,
  onSave,
  initialValues
}) {
  const { getTranslation } = useLanguage();

  const [label, setLabel] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  // LocalStorage defaults
  const storedEmail = localStorage.getItem("email") || "";
  const storedPhone = localStorage.getItem("phoneNumber") || "";

  useEffect(() => {
    if (!isOpen) return;

    setLabel(initialValues?.label || "");
    setCity(initialValues?.city || "");
    setDistrict(initialValues?.district || "");
    setPostalCode(initialValues?.postalCode || "");
    setAddress(initialValues?.address || "");
    setPhone(initialValues?.phone || storedPhone);
    setEmail(initialValues?.email || storedEmail);
  }, [isOpen, initialValues, storedEmail, storedPhone]);

  if (!isOpen) return null;

  const handleSaveClick = () => {
    onSave({
      label,
      city,
      district,
      postalCode,
      address,
      phone,
      email
    });
  };

  return (
    <div className="new-address-modal-overlay" onClick={onClose}>
      <div
        className="new-address-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="new-address-modal-title">
          {getTranslation("newAddressTitle")}
        </h2>

        <div className="new-address-modal-body">
          {/* Adres adı / başlık */}
          <InputField
            label={getTranslation("saveAddressTitle") || "Adres Adı"}
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder={getTranslation("saveAddressPlaceholder") || "Ev 1"}
            disabled={!!initialValues}
          />

          <InputField
            label={getTranslation("newAddressLabelAddress")}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder={getTranslation("newAddressPlaceholderAddress")}
            disabled={!!initialValues}
          />

          <InputField
            label={getTranslation("newAddressLabelCity")}
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder={getTranslation("newAddressPlaceholderCity")}
            disabled={!!initialValues}
          />

          <InputField
            label={getTranslation("newAddressLabelDistrict")}
            value={district}
            onChange={(e) => setDistrict(e.target.value)}
            placeholder={getTranslation("newAddressPlaceholderDistrict")}
            disabled={!!initialValues}
          />

          <InputField
            label={getTranslation("newAddressLabelPostalCode")}
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
            placeholder={getTranslation("newAddressPlaceholderPostalCode")}
            disabled={!!initialValues}
          />

          <InputField
            label={getTranslation("newAddressLabelPhone")}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder={getTranslation("newAddressPlaceholderPhone")}
            disabled={!!initialValues}
          />

          <InputField
            label={getTranslation("newAddressLabelEmail")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={getTranslation("newAddressPlaceholderEmail")}
            disabled={!!initialValues}
          />
        </div>

        {!initialValues ?
          <div className="new-address-modal-footer">
            <Button
              style={{ width: "48%" }}
              label={getTranslation("newAddressCancel")}
              onClick={onClose}
            />
            <Button
              style={{ width: "48%" }}
              label={getTranslation("newAddressSave")}
              onClick={handleSaveClick}
            />
          </div> :
          <div className="new-address-modal-footer">
            <Button
              style={{ width: "100%" }}
              label={getTranslation("newAddressCancel")}
              onClick={onClose}
            />
          </div>
        }

      </div>
    </div>
  );
}